import { useUserStore } from '@/stores/user'
import { useCookies } from '@vueuse/integrations/useCookies.mjs'
import type { RouteLocation } from 'vue-router'

/**
 * If the user is logged in, their details are fetched and added to the user store.
 */
export default async function fetchUserDetailsGuard(to: RouteLocation) {
  const userStore = useUserStore()
  const cookies = useCookies(['authToken', 'impersonated'], {
    autoUpdateDependencies: true,
  })

  if (to.name === 'impersonate') {
    cookies.remove('authToken', { path: '/' })
    cookies.remove('impersonated', { path: '/' })
  }

  if (cookies.get('authToken')) {
    try {
      await userStore.fetchDetails()
    } catch (e: any) {
      // TODO: Add Datadog custom log
    }
  }
}
